import { useMutation } from '@tanstack/react-query';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { functionalityResponseFactory } from '../../utils/functionalityFunnelsPageFactory';

export function useTryToRequestFunctionalityPage() {
  const { mutateAsync } = useMutation({
    mutationFn: async (id: string) => {
      const response =
        await apiCancellationFunnels.tryToRequestGetOneCancellationFunnelPage(
          id
        );

      const factory = functionalityResponseFactory(response.data);

      return factory;
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao solicitar dados de Funcionalidade',
        'Ocorreu um erro ao solicitar dados de Funcionalidade, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestFunctionality: mutateAsync,
  };
}
